import React from 'react';
import { SkeletonLoader } from '../../../../components/general/loading-state/loaders/skeleton-loader/skeleton-loader';

export function DetailsStepSkeleton(): JSX.Element {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, width: '100%' }}>
      <SkeletonLoader height="200px" />
      <SkeletonLoader height="500px" />
      <SkeletonLoader height="50px" />
    </div>
  );
}
